import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import ButtonGroup from '@mui/material/ButtonGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { IconButton } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';
import { DriveOnTargetDto as Target } from '@/generated/model';

import './TargetConfirmationDialog.css';

import { useTranslation } from 'react-i18next';

type VehicleDialogProps = {
  target: Target;
  message: string;
  onClose: () => void;
  onAccept: () => void;
};

export function VehicleDialog({ message, target, onClose, onAccept }: VehicleDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={true}>
      <DialogTitle>
        <Stack direction={'row'} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography sx={{ fontWeight: 'bold', size: 24 }}>{t('general.warning') + ' ' + target.name}</Typography>
          <IconButton>
            <CloseOutlined onClick={() => onClose()} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>{message}</DialogContent>
      <DialogActions>
        <ButtonGroup fullWidth>
          <Button
            fullWidth
            variant="outlined"
            onClick={onAccept}
            startIcon={<CheckCircleIcon />}
            sx={{ color: 'white', backgroundColor: 'red !important' }}
            style={{ margin: '2px' }}
          >
            {t('general.accept')}
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={onClose}
            startIcon={<ClearIcon />}
            sx={{ color: 'white', backgroundColor: 'grey !important' }}
            style={{ margin: '2px' }}
          >
            {t('general.cancel')}
          </Button>
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  );
}
